import { NavigationPath } from '@/router/navigation-path.ts';

export const NavigationRuleName = {
	IS_LOADING: 'isLoading',
	NOT_AUTHENTICATED: 'notAuthenticated',
	IS_APPLICANT_REVIEW: 'isApplicantReview',
	IS_APPLICANT_ONBOARDING: 'isApplicantOnboarding',
	NEEDS_RECURRING_CALENDAR_SETUP: 'needsRecurringCalendarSetup',
	IS_RESTRICTED: 'isRestrictedForServiceType'
};

export const RestrictedPages = {
	GOT_IT: [NavigationPath.coachAppointments, NavigationPath.coachRecurringCalendar] as string[],
	GOT_IT_APPOINTMENT: [NavigationPath.coachAppointments, NavigationPath.coachRecurringCalendar] as string[],
	COACHING: [NavigationPath.gotItRecurringCalendar] as string[],
	COACHING_INSTANT: [NavigationPath.coachAppointments, NavigationPath.gotItRecurringCalendar] as string[],
	SOLVER: [NavigationPath.coachAppointments, NavigationPath.coachRecurringCalendar] as string[]
};

export const DefaultPagesForServiceTypes = {
	GOT_IT: NavigationPath.gotItInstantMeetings,
	GOT_IT_APPOINTMENT: NavigationPath.gotItAppointments,
	COACHING: NavigationPath.coachAppointments,
	COACHING_INSTANT: NavigationPath.coachInstantMeetings,
	SOLVER: NavigationPath.solverSolve
};
